import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron",
  "use": "chevron-usage",
  "viewBox": "0 0 5 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5 9\" id=\"chevron\"><path fill-rule=\"evenodd\" d=\"M4.98 4.179a.288.288 0 0 1-.083.192l-3.9 3.9a.288.288 0 0 1-.193.084.288.288 0 0 1-.193-.083l-.418-.419a.272.272 0 0 1-.084-.192c0-.067.033-.143.084-.193l3.29-3.29L.192.889A.288.288 0 0 1 .109.697C.109.63.142.554.193.504L.61.085A.288.288 0 0 1 .804.002c.067 0 .142.033.192.083l3.9 3.901c.051.05.084.126.084.193z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol